import React from 'react';

import './styles.scss';
import {Logo} from '../helpers/Logo';
import AccountDisplay from './components/AccountDisplay';
import {Ripple} from "../../../helpers/Buttons";
import {API_URL_HOST} from "../../../../config/api";
import changeHostnamePopup from "./utils/changeHostnamePopup";

export default ({children}) => {

  const showAPISelect = ['dev'].some((key) => location.hostname.includes(key));

  return (
    <div className="auth-layout">
      <div className="auth-layout__header">
        <Logo text="console" />
        <AccountDisplay />
      </div>
      <div className="auth-layout__content">
        {children}
      </div>
      <div className="auth-layout__footer">
        {showAPISelect && (
          <div className="auth-layout__change-api">
            <Ripple onClick={changeHostnamePopup}>
              Current API: {API_URL_HOST}
            </Ripple>
          </div>
        )}
      </div>
    </div>
  )
}
